import { OnInit, AfterViewInit, ChangeDetectorRef, EventEmitter, Component, Input, ViewChild, Output, SimpleChanges, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { UserMatrixModel } from '../../models/user-matrix-model';
import { SelectionModel } from '@angular/cdk/collections';
import { UserMatrixRowModel } from '../../models/user-matrix-row-model';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { MatrixRowModel } from '../../models/templatesModels/matrix-row-model';

@Component({
    selector: 'app-matrix-sorting',
    templateUrl: './matrix-sorting.component.html',
    styleUrls: ['./matrix-sorting.component.scss'],
})
export class MatrixSortingComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() searchData: string;
    @Input() data: MatrixRowModel[];
    @Output() refreshMatrix1: EventEmitter<boolean> = new EventEmitter();
    @ViewChild(MatSort) sort: MatSort;

    spinerDisplay: boolean = false;
    searchKey: string;
    selectedUserMatrixRowIDItems = [];
    dataSource = new MatTableDataSource([]);
    selection = new SelectionModel<UserMatrixModel>(true, []);

    constructor(
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService
    ) {}

    displayedColumns: string[] = [
        'select',
        'jointId',
        'calculationType',
        'calculationDate',
        'pressureClassName',
        'pipeSize',
        'gasketName',
        'residualBoltLoad',
        'residualBoltStress',
        'tighteningMethod',
        'toolName',
        'toolPressure',
        'action',
    ];

    ngOnInit(): void {
        this.globalEmittersService.refreshLoader.subscribe((res) => {
            if (res != null) {
                this.spinerDisplay = res;
                this.cd.detectChanges();
            }
        });
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data) {
            this.dataSource = new MatTableDataSource(changes.data.currentValue);

            setTimeout(() => {
                this.dataSource.sort = this.sort;
            }, 3000);
        }
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    userMetrixRefresh(event: boolean) {
        this.refreshMatrix1.emit(true);
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    applyFilter(filterData: string) {
        const filterValue = filterData;
        this.dataSource.filter = filterValue?.trim()?.toLowerCase();
    }

    OnChange($event, row?: UserMatrixModel) {
        !$event ? null : this.selection.toggle(row);

        // If checked, add to our collection
        if ($event.checked) {
            this.selectedUserMatrixRowIDItems.push(row);
        }
        // If unchecked, check whether the item already checked and added to our collection . Remove that
        if (!$event.checked) {
            const index = this.selectedUserMatrixRowIDItems.findIndex((x) => x.userMatrixRowId === row.userMatrixRowId);
            if (index !== -1) {
                this.selectedUserMatrixRowIDItems.splice(index, 1);
            }
        }
    }

    // * check text is overflowing or not
    checkTextOverFlow(matrixId: string) {
        const element = document.getElementById(matrixId);
        if (element) {
            return element.scrollWidth > element.clientWidth;
        } else {
            return false;
        }
    }
}
